import { useSelector } from "react-redux";
import BootstrapModal from "./BootstrapModal";
import DiscountErrorModalContent from "./DiscountErrorModalContent";
import { getDiscountError } from "shared/utility";

export default function DiscountErrorModal({ open, onDismiss }) {
  const { cart, checkoutError } = useSelector((s) => s.checkout);

  const code = cart.discount?.code || "N/A";
  const message = getDiscountError(checkoutError);

  return (
    <BootstrapModal isVisible={open} onDismissed={onDismiss}>
      <DiscountErrorModalContent
        message={message}
        code={code}
        onDismiss={onDismiss}
      />
    </BootstrapModal>
  );
}
